import { LiveChatArticle } from 'api/types';
import MessageMetadata from 'components/MessageMetadata/MessageMetadata';
import React from 'react';

interface ArticlesMessageProps {
  articles: LiveChatArticle[];
}

export const ArticlesMessage: React.FC<ArticlesMessageProps> = ({
  articles,
}) => {
  return (
    <>
      {articles.map(article => (
        <MessageMetadata
          key={article.link}
          metadata={{
            description: article.preview,
            image: null,
            title: article.title,
            url: article.link,
          }}
        />
      ))}
    </>
  );
};
